import { Service } from '@genial/services';
import { InitOverrideFunction } from '@genial/services/src/runtime';

import { screenName } from '../../../store/fixedFeeTermAcceptanceLink/constants';

export const postTfaCodeService = async (termId: string, tfaCode: string) => {
  const initOverrideFunction: InitOverrideFunction = async ({ init }) => {
    const headers = new Headers(init.headers);
    headers.append('Authorization', '');

    return {
      ...init,
      headers,
    };
  };
  const { data, statusCode } = await Service.Authentication.V1.postTfaTokenFixedFeeValidate(
    {
      screenName,
      validateFixedFeeTfaTokenRequest: {
        fixedFeeAgreementId: termId,
        tfaCode,
      },
    },
    initOverrideFunction
  );

  if (statusCode === 200) {
    return data;
  }

  throw new Error('Não foi possível processar a requisição.');
};
